<h2 style="cursor:pointer;" class="flex-aligned-div" (click)="openLogsHistory()">
  @if (defaults.isadminuser) {
    <button mat-icon-button (click)="openCreatePopup(); $event.stopPropagation()" matTooltip="Add new Parameter Config">
      <mat-icon>add</mat-icon>
    </button>
  }
  <span class="logs-history-label">
    Logs History
    <mat-icon data-html="true" style="color:white">info</mat-icon>
  </span>
</h2>
<div class="example-container">
  <table mat-table
    [dataSource]="dataSource"
    multiTemplateDataRows
    matSort
    class="mat-elevation-z8 mat-table-custom" id="parametersconfig">
    @for (item of columnsToDisplay; track item) {
      <ng-container matColumnDef="{{item}}">
        <th mat-header-cell *matHeaderCellDef>
          {{item === 'Enabled' ? '' : item}}
          @if (item !== 'Enabled') {
            <mat-icon class="info-tooltip" matTooltipClass='opmodes-custom-tooltip' data-html="true" matTooltip="{{tooltips[item]}}">info</mat-icon>
          }
        </th>
        @if (item==='Enabled') {
          <td mat-cell *matCellDef="let element">
            @if (defaults.isControllerOwner) {
              @if (getInput(element,'Enabled') === true) {
                <button mat-icon-button (click)="changeElement(element, 'Enabled', false)" matTooltip="Disallow Parameter Config">
                  <mat-icon class="mat-icon-green">toggle_on</mat-icon>
                </button>
              }
              @if (!getInput(element,'Enabled')) {
                <button mat-icon-button (click)="onRowEditInit(element, true)" matTooltip="Allow Parameter Config">
                  <mat-icon class="mat-icon-grey">toggle_off</mat-icon>
                </button>
              }
              @if (getInput(element,'Enabled')) {
                <button mat-icon-button matTooltip="Edit Row" (click)="onRowEditInit(element, element.Enabled)">
                  <mat-icon>edit</mat-icon>
                </button>
              }
            }
            @if (!defaults.isControllerOwner) {
              @if (getInput(element,'Enabled') === true) {
                <p class="mat-icon-green">Enabled</p>
              }
              @if (getInput(element,'Enabled') === false) {
                <p class="mat-icon-grey">Disabled</p>
              }
            }
          </td>
        }
        @if (item==='ControllerParameterId') {
          <ng-container *matCellDef="let element">
            @switch (getDataType(item)) {
              @case ('string') {
                <td mat-cell>
                  <p [innerHTML]="highlightWithKeywords(getInput(element,item))"></p>
                </td>
              }
            }
          </ng-container>
        }
        @if (item==='ShowCustomer') {
          <ng-container *matCellDef="let element">
            <td mat-cell>
              @if (defaults.isControllerOwner) {
                @if (getInput(element,'ShowCustomer') === true) {
                  <button mat-icon-button (click)="changeElement(element, 'ShowCustomer', false)" matTooltip="Hide to customer">
                    <mat-icon class="mat-icon-green">toggle_on</mat-icon>
                  </button>
                }
                @if (!getInput(element,'ShowCustomer')) {
                  <button mat-icon-button (click)="changeElement(element, 'ShowCustomer', true)" matTooltip="Show to customer">
                    <mat-icon class="mat-icon-grey">toggle_off</mat-icon>
                  </button>
                }
              }
              @if (!defaults.isControllerOwner) {
                @if (getInput(element,'ShowCustomer') === true) {
                  <p class="mat-icon-green">Enabled</p>
                }
                @if (getInput(element,'ShowCustomer') === false) {
                  <p class="mat-icon-grey">Disabled</p>
                }
              }
            </td>
          </ng-container>
        }
        @if (item!=='Enabled' && item!=='ControllerParameterId') {
          <ng-container *matCellDef="let element">
            @switch (getDataType(item)) {
              @case ('string') {
                <td mat-cell>
                  <p [innerHTML]="getInput(element,item)"></p>
                </td>
              }
            }
          </ng-container>
        }
      </ng-container>
    }

    <tr mat-header-row class="tableheader" *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let element; let i = dataIndex; columns: columnsToDisplay;" class="item">
    </table>
  </div>
